import React, {useEffect, useMemo, useState} from "react";
import { useSearchParams } from "react-router-dom";
import SearchBox from "../../components/general/searchBox";
import { useWindowSize } from "../../../hook/useWindowSize";
import { useMySearchParams } from "../../../hook/useMySearchParams";
import Pagination from "../../components/general/table/pagination";
import {useFindAccessInAccessList} from "../../../constants/constant/accessProcess";
import {
    useGetPrescriptionReferralList
} from "../../../hook/request/ihioPrescriptionFilling";
import PrescriptionReferralTable from "../../components/ihioPrescriptionReferral/prescriptionReferralTable";
import {useForm} from "react-hook-form";
import DatePickerField from "../../components/general/form/datePickerField";
import moment from "moment";
import IhioPrescriptionReferralInfo
    from "../../components/ihioPrescriptionReferral/ihioPrescriptionReferralInfoModal/ihioPrescriptionReferralInfoModal";

const dataListTitles = [
    "نام و نام خانوادگی",
    "تخصص",
    "شناسه رهگیری",
    "تاریخ",
    "عملیات",
]

type TFilterValues = {
    pageNumber?: string;
    perPage?: string;
    search?: string;
    fromDate?: string;
    toDate?: string;
    nationalCode?: string;
    feedBack?: boolean;
}

const PrescriptionReferralList = () => {

    const [width] = useWindowSize();
    const {findAccessInAccessList} = useFindAccessInAccessList();
    const [searchParams] = useSearchParams();
    const { getQueryParams, updateSearchParams } = useMySearchParams();
    const [prescriptionReferralData, setPrescriptionReferralData] = useState([]);
    const [filterValues, setFilterValues] = useState<TFilterValues>({
        pageNumber: "0",
        perPage: "10",
        search: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<TFilterValues>({
        defaultValues: useMemo(() => filterValues, [filterValues]),
    });


    // services
    const getPrescriptionReferralListRequest = useGetPrescriptionReferralList(getQueryParams(filterValues));

    useEffect(() => {
        let _filterValues = {};
        _filterValues = {
            ...filterValues,
            pageNumber: searchParams.get("pageNumber") || "0",
            perPage: searchParams.get("perPage") || "10",
            search: searchParams.get("search") || "",
            fromDate: searchParams.get("fromDate") || "",
            toDate: searchParams.get("toDate") || "",
        }
        setFilterValues(_filterValues)
    }, [searchParams]);

    useEffect(() => {
        getPrescriptionReferralListRequest?.data?.data?.result &&
        setPrescriptionReferralData(getPrescriptionReferralListRequest?.data?.data.result)
    }, [getPrescriptionReferralListRequest.data])

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        let formatted = {}
        if(name === 'fromDate' || name === 'toDate') {
            const momentDate = moment.tz(value, 'Asia/Tehran');
            formatted = momentDate.format('YYYY-MM-DDTHH:mm:ss');
        }

        updateSearchParams({
            pageNumber: "0",
            perPage: filterValues?.perPage,
            [name]: (name === 'fromDate' || name === 'toDate') ? formatted : value,
        })
    }

    const doChangePage = (param: any) => {
        updateSearchParams({
            pageNumber: param?.index,
            perPage: filterValues?.perPage,
        })
    }

    return (
        <>
            <div className="card-box">
                <section className="filter-box d-flex flex-column flex-md-row mb-4">
                    <div className="form-group d-flex align-items-center gap-2 ms-md-auto">
                        <SearchBox
                            name="search"
                            value={filterValues?.search}
                            onChange={handleFilterChange}
                            placeholder="جستجوی تجویز"
                        />
                        <DatePickerField
                            name="fromDate"
                            placeholder="تاریخ شروع"
                            control={control}
                            error={errors}
                            onChange={handleFilterChange}
                        />
                        <DatePickerField
                            name="toDate"
                            placeholder="تاریخ پایان"
                            control={control}
                            error={errors}
                            onChange={handleFilterChange}
                        />
                        {/*<button*/}
                        {/*    onClick={() => getPrescriptionReferralListRequest?.refetch()}*/}
                        {/*    className="btn btn-primary rounded d-flex align-items-center text-nowrap fw-bold px-4 ms-2"*/}
                        {/*>*/}
                        {/*    <span className="d-inline-flex font-25 ms-2 ps-2"><Icon name="filter"/></span>*/}
                        {/*    اعمال فیلتر*/}
                        {/*</button>*/}
                    </div>
                </section>

                <section className="table-cont table-responsive">
                    <PrescriptionReferralTable
                        dataList={prescriptionReferralData}
                        dataListTitles={dataListTitles}
                        isRequesting={getPrescriptionReferralListRequest.isPending}
                    />
                    <Pagination
                        paginationData={{...filterValues, ...prescriptionReferralData}}
                        doChangePage={doChangePage}
                    />
                </section>
            </div>

            <IhioPrescriptionReferralInfo />
        </>
    );
};

export default PrescriptionReferralList;